import React from 'react';

const ProjectSection = () => {
  const industryProjects = [
    { id: 1, src: "/images/keyword/1.jpg", title: "Alluminium Glass Office Partition" },
    { id: 2, src: "/images/keyword/2.jpg", title: "Toughened Glass Work" },
    { id: 3, src: "/images/keyword/3.jpg", title: "Door Partition" },
    { id: 4, src: "/images/keyword/4.jpg", title: "ACP Cladding Panel Installation" },
  ];

  const manufacturingProjects = [
    { id: 1, src: "/images/keyword/5.jpg", title: "Alluminium Glass Window" },
    { id: 2, src: "/images/keyword/6.jpg", title: "Sound Proof Glass Window" },
    { id: 3, src: "/images/keyword/7.jpg", title: "Alluminium Mosquito Net" },
    { id: 4, src: "/images/keyword/8.jpg", title: "Bird Net Installation" },
    { id: 5, src: "/images/keyword/9.jpg", title: "Invisible Grill Installation" },
  ];

  const renderProjects = (projects) => {
    return projects.map((project) => (
      <div className="item" key={project.id}>
        <div className="col-md-4 col-sm-6 col-xs-12 img homeprj3-slide">
          <div className="grid">
            <div className="image-zoom-on-hover">
              <div className="gal-item">
                <a className="black-hover" href="#">
                  <img
                    width="360"
                    height="278"
                    src={project.src}
                    className="attachment-360x278 size-360x278 wp-post-image"
                    alt="img"
                  />
                  <div className="tour-layer delay-1"></div>
                  <div className="vertical-align">
                    <div className="border">
                      <h5>{project.title}</h5>
                      {/* Add the button in the center */}
                      <button className="project-button">VIEW DETAILS</button>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <section>
      <div role="tabpanel" className="tab-pane" id="industry">
        <div className="full_wrapper" id="our_project4" data-ride="carousel">
          {renderProjects(industryProjects)}
        </div>
      </div>

      <div role="tabpanel" className="tab-pane" id="manufacturing">
        <div className="full_wrapper" id="our_project5" data-ride="carousel">
          {renderProjects(manufacturingProjects)}
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
